var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.799,
    height: 28.211,
    viewBox: "0 0 29.799 28.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.559,39.277a1.6,1.6,0,0,1-1.585,1.585h-4.39A1.581,1.581,0,0,1,11,39.277V26.835a1.581,1.581,0,0,1,1.585-1.585h4.369a1.581,1.581,0,0,1,1.585,1.585V39.277Zm18.588-9.765a2.178,2.178,0,0,1,.343,3.062,2.1,2.1,0,0,1-1.2.75,2.155,2.155,0,0,1,.343,3.041,2.229,2.229,0,0,1-1.221.771,2.183,2.183,0,0,1-1.371,3.876l-12.313-.128A1.581,1.581,0,0,1,20.144,39.3V26.835c0-1.97,6.3-5.589,6.617-7.538.214-1.285-.064-4.5.792-4.5,1.478,0,3.341.557,3.341,3.812,0,2.87-1.884,6.6-1.884,6.6h7.623A2.157,2.157,0,0,1,38.8,27.37a2.087,2.087,0,0,1-1.649,2.141Z",
    transform: "translate(39.799 42.011) rotate(180)",
    fill: "none",
    stroke: "#3f9dfb",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDownIcon);
export default __webpack_public_path__ + "static/media/thumbDownIcon.643b8c96fb56d62831a8749d1e0b3d10.svg";
export { ForwardRef as ReactComponent };